import gql from 'graphql-tag';

export const removeManualMutation = gql`
  mutation removeManual($manualId: String!) {
    removeManual(manualId: $manualId)
  }
`;
